import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';

@Component({
	selector: 'timer',
	template: require('./timer.component.html')
})
export class TimerComponent implements OnInit, OnDestroy {
	@Input()
	public seconds: number;

	@Input()
	public timerDescription: string = 'Remaining';

	@Output()
	public onTimerDone: EventEmitter<boolean> = new EventEmitter();

	private remainingSeconds: number;
	private interval: any = undefined;
	private formattedTime: string = undefined;
	private isDone = false;

	public ngOnInit(): void {
		this.resetTimer();
	}

	public ngOnDestroy(): void {
		if (this.interval) {
			clearInterval(this.interval);
		}
	}

	public resetTimer(updatedSeconds?: number): void {
		this.isDone = false;
		if (updatedSeconds) {
			this.seconds = updatedSeconds;
		}

		this.remainingSeconds = updatedSeconds;

		this.formatOutput(this.remainingSeconds);
		this.remainingSeconds--;

		if (this.interval) {
			clearInterval(this.interval);
		}

		this.interval = setInterval(() => {
			this.updateUI();
		}, 1000);
	}

	private updateUI(): void {
		this.formatOutput(this.remainingSeconds);
		this.remainingSeconds--;
		if (this.remainingSeconds == 0) {
			this.timerDone();
		}
	}

	private timerDone(): void {
		clearInterval(this.interval);
		this.isDone = true;
		this.onTimerDone.emit(this.isDone);
	}

	private formatOutput(seconds: number): void {
		let minutes = Math.floor(seconds / 60);
		this.formattedTime =
			('0' + minutes).slice(-2) + ':' + ('0' + (seconds - minutes * 60)).slice(-2);
	}
}
